/**
 * Atualizar a guia de um aviso (o `document_id` que vem nos problemas de guia
 * vinculada) sem abrir a ficha: carrega a guia, as carteirinhas e os pedidos da
 * pessoa e abre o mesmo formulário da ficha. `status` (opcional) já vem trocado,
 * para "Marcar autorizada" virar um formulário com a senha e a validade à mão.
 * `onSaved` roda uma vez, depois dos anexos (o aviso recarrega com tudo pronto).
 */
import React, { useEffect, useState } from 'react';
import { DataProviderInstance } from '../../../../../api/DataProvider';
import AuthorizationFormPopup from '../../../../patient/areas/insurance/documents/AuthorizationFormPopup';
import { authorizationPayload } from '../../../../patient/areas/insurance/documents/useInsuranceDocuments';

function GuideUpdatePopup({ patientId, guideId, status, onSaved, onClose, onError }) {
  const {
    CompanyConfig, GetPatientInsuranceDocuments, GetPatientInsurances, UpdateInsuranceAuthorization,
  } = DataProviderInstance();
  const [data, setData] = useState(null);

  useEffect(() => {
    let alive = true;
    GetPatientInsuranceDocuments(patientId, (docs) => {
      GetPatientInsurances(patientId, (cards) => {
        if (!alive) return;
        const authorizations = docs?.status === 'SUCCESS' ? (docs.data?.authorizations || []) : [];
        const guide = authorizations.find((g) => String(g.id) === String(guideId));
        if (!guide) {
          if (onError) onError('Não foi possível abrir a guia. Tente de novo.');
          onClose();
          return;
        }
        setData({
          guide,
          requests: docs.data?.requests || [],
          cards: cards?.status === 'SUCCESS' ? (cards.data?.insurances || []) : [],
        });
      });
    });
    return () => { alive = false; };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [patientId, guideId]);

  if (!data) return null;

  const save = (values) => new Promise((resolve) => {
    UpdateInsuranceAuthorization({ ...authorizationPayload(patientId, data.guide), ...values }, (result) => {
      if (result?.status === 'SUCCESS') {
        resolve({ ok: true, id: data.guide.id });
        return;
      }
      resolve({ ok: false, error: result?.error || result?.message || 'Não foi possível salvar a guia. Tente de novo.' });
    });
  });

  return (
    <AuthorizationFormPopup
      authorization={status ? { ...data.guide, status } : data.guide}
      insurances={data.cards}
      providers={CompanyConfig?.InsuranceProviders || []}
      requests={data.requests}
      patientId={patientId}
      onSave={save}
      onSaved={() => { if (onSaved) onSaved(); }}
      onClose={onClose}
    />
  );
}

export default GuideUpdatePopup;
